export const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image()

    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', (error) => reject(error))
    image.src = url
  })

interface PixelCrop {
  x: number
  y: number
  width: number
  height: number
}

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */
// eslint-disable-next-line import/no-default-export
export default async function getCroppedImg(
  imageSrc: string,
  pixelCrop: PixelCrop,
): Promise<Blob | null> {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    return null
  }

  // set canvas size to match the image size
  canvas.width = image.width
  canvas.height = image.height

  // clear the canvas
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  // draw the image
  ctx.drawImage(image, 0, 0)

  const croppedCanvas = document.createElement('canvas')

  const croppedCtx = croppedCanvas.getContext('2d')

  if (!croppedCtx) {
    return null
  }

  // Set the size of the cropped canvas
  croppedCanvas.width = pixelCrop.width
  croppedCanvas.height = pixelCrop.height

  // clear the cropped canvas
  croppedCtx.clearRect(0, 0, croppedCanvas.width, croppedCanvas.height)

  // Draw the cropped image onto the new canvas
  croppedCtx.drawImage(
    canvas,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height,
  )

  // As a blob
  return new Promise((resolve, reject) => {
    croppedCanvas.toBlob((file) => {
      if (file) {
        resolve(file)
      } else {
        reject(new Error('Failed to create blob'))
      }
    }, 'image/png')
  })
}
